import { Button } from 'semantic-ui-react';
import './styles.scss';
import { useTranslation } from 'react-i18next';

export const NotFound = (props) => {
  const { navigate } = props;
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <div>
        <label className="nfheader">
          4<span>&#9785;</span>4
        </label>
        <label className="nfdetails">{t('error.404.description')}</label>
        <Button
          className="nfbutton"
          content={t('error.404.button')}
          onClick={() => navigate('/')}
        />
      </div>
    </div>
  );
};

export const PermissionDenied = (props) => {
  const { t } = useTranslation();

  return (
    <div className="permission-denied">
      <div className="container">
        <label className="status">403</label>
        <label className="header">{t('error.403.title')}</label>
        <label className="note">{t('error.403.description')}</label>
      </div>
    </div>
  );
};
